import React, { forwardRef } from 'react';
import style from './Modal.module.css';
import { Modal as BaseModal, prepareForSlot } from '@mui/base';
import { cl } from 'lincd/utils/ClassNames';
export const Modal = ({ isOpen = false, onClose, backdrop, children, renderContent, }) => {
    const handleClose = () => {
        onClose();
    };
    return (React.createElement(BaseModal, { "aria-labelledby": "unstyled-modal-title", "aria-describedby": "unstyled-modal-description", open: isOpen, onClose: handleClose, 
        // slots={{backdrop: BackdropSlot}} disable slots for make Backdrop component can pass props
        className: style.modal },
        React.createElement(React.Fragment, null,
            React.createElement(Backdrop, { open: isOpen, backdrop: backdrop, onClose: handleClose }),
            React.createElement("div", { className: style.content }, renderContent ? renderContent : children))));
};
const Backdrop = forwardRef((props, ref) => {
    const { open, backdrop, onClose, ...other } = props;
    // check has custom backdrop
    const hasBackdrop = backdrop ? { backgroundColor: backdrop } : {};
    return (React.createElement("div", { ref: ref, className: cl(open && style.backdrop), "aria-hidden": true, onClick: onClose, style: hasBackdrop, ...other }));
});
// https://mui.com/base-ui/getting-started/customization/#overriding-subcomponent-slots
const BackdropSlot = prepareForSlot(Backdrop);
//# sourceMappingURL=Modal.js.map